module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"DeleteSuccess":"La règle a bien été supprimée","CreateSuccess":"La règle a bien été ajoutée","EditSuccess":"La règle a bien été modifiée"}}')
  delete Component.options._Ctor
}
